<template>
  <div class="home">
    <Headers></Headers>
    <HeaderCover></HeaderCover>
    <div class="about">
      <img :src="about" alt="" class="a-cover">
      <div class="title-Box">
        <div class="title">
          <div class="chinese">关于我们</div>
          <div class="hx"></div>
          <div class="eng">About us</div>
<!--          <div class="subtitle">安全评价和咨询服务</div>-->
          <div class="ab-con">
            常州苏态安全环保科技有限公司为建设项目提供环保咨询服务；环境保护监测服务；土壤污染治理与修复服务；安全咨询服务；安全评价；职业卫生技术服务；工程设计；环境保护专用设备销售；节能管理服务；企业管理咨询等多项目咨询服务。
          </div>
        </div>
      </div>
    </div>
    <div class="business">
      <div class="title-Box active">
        <div class="title active">
          <div class="chinese">主营业务</div>
          <div class="hx"></div>
          <div class="eng">Main business</div>
        </div>
        <div class="tab">
          <div class="t-text" v-for="(item,index) in tab" :class="mrIndex===index?'active':''" @click="tabSelect(index)">{{ item.title}}</div>
        </div>
      </div>
      <div class="b-list">
        <div class="item-box" :style="{backgroundImage:'url('+ywBox+')'}" v-for="(item1,index1) in tabList">
          <div class="item-con">
            <img class="i-url"  :src="item1.operation_image">
            <div class="i-title">{{item1.name}}</div>
            <div class="i-con" v-html="item1.content"></div>
            <div class="i-more"  @click="yewu(index1)">了解更多</div>
          </div>
        </div>
      </div>
    </div>
    <div class="file">
      <div class="title-Box active">
        <div class="title active">
          <div class="chinese">文件公示</div>
          <div class="hx"></div>
          <div class="eng">Document publicity</div>
        </div>
        <div class="more" @click="tzfile">查看更多</div>
      </div>
      <div class="f-list">
        <img :src="file" alt="" class="f-cover">
        <div class="f-con">
          <div class="f-text" v-for="(item2,index2) in docList" v-if="index2<5" @click="tzfile">
            <div class="f-dian"></div>
            <div class="f-title">{{item2.title}}</div>
            <div class="f-time">{{item2.time}}</div>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="business active">-->
<!--      <div class="title-Box active">-->
<!--        <div class="title active">-->
<!--          <div class="chinese">公司资质</div>-->
<!--          <div class="hx"></div>-->
<!--          <div class="eng">Company qualification</div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="comp">-->
<!--        <img :src="item3.url" alt="" class="b-url" v-for="(item3,index3) in book">-->
<!--      </div>-->
<!--      <div class="c-text">公司资质安全保障</div>-->
<!--      <div class="c-eng">Company Qualification Safety Guarantee</div>-->
<!--    </div>-->
    <Foots></Foots>
  </div>
</template>

<script>
import Headers from '@/views/component/Header.vue'
import SmallTitle from '@/views/component/SmallTitle.vue'
import HeaderCover from '@/views/component/HomeCover.vue'
import Foots from '@/views/component/Foot.vue'
import axios from 'axios'
export default {
  name: "Home",
  components: {
    Headers,
    HeaderCover,
    SmallTitle,
    Foots
  },
  data() {
    return {
      mrIndex:0,
      tabShow:false,
      docList:null,
      tabList:'',
      file:require('@/assets/home/file.jpg'),
      ywBox:require('@/assets/home/boder.jpg'),
      fileList:[
        {
          title:'某某某公司的安全评价和咨询服务文件公示安全评价和咨询服务文件公示',
          time:'2022-11-02'
        },
        {
          title:'某某某公司的安全评价和咨询服务文件公示安全评价和咨询服务文件公示',
          time:'2022-11-02'
        },
        {
          title:'某某某公司的安全评价和咨询服务文件公示安全评价和咨询服务文件公示',
          time:'2022-11-02'
        },
        {
          title:'某某某公司的安全评价和咨询服务文件公示安全评价和咨询服务文件公示',
          time:'2022-11-02'
        },
        {
          title:'某某某公司的安全评价和咨询服务文件公示安全评价和咨询服务文件公示',
          time:'2022-11-02'
        },
        {
          title:'某某某公司的安全评价和咨询服务文件公示安全评价和咨询服务文件公示',
          time:'2022-11-02'
        },
      ],
      book:[
        {
          url:require('@/assets/business/1.png')
        },
        {
          url:require('@/assets/comp.jpeg')
        },
        {
          url:require('@/assets/business/2.png')

        },
      ],
      list: [
        {
          url: require('@/assets/home/banner.jpg'),
          bt: '专注于安全',
          title: '安全系统工程的一个重要组成部分',
          eng: 'An important part of safety systems engineering'
        }
      ],
      tab: [
        {
          title: '安全'
        },
        {
          title: '环境'
        },
        {
          title: '职业卫生'
        },
      ],
      aqList:[
            {
              type:1,
              url:require('@/assets/type/1/1.png'),
              title:'安全评价',
              content:'安全评价（safety evaLuatlon），亦称“危险评价”、“风险评价”。探明系统危险、寻求安全对策的一种方法和技术。安全系统工程的一个重要组成部分。旨在在建立必要的安全措施前，掌握系统内可能的危险种类、危险程度和危险后果，并对其进行定量、定性的分析，从而提出有效的危险控制措施。可用事故率评价指标，也可用工效学方法评价，如通过业务分析、实验方法、模拟法、可靠性测定和动作时间研究等进行评价。'
            },
            {
              type:1,
              url:require('@/assets/type/1/2.png'),
              title:'安全标准化',
              content:'以及目标职责、制度化管理、教育培训、现场管理、安全风险管控及隐患排查治理、应急管理、事故管理和持续改进8个体系的核心技术要求。修订安全生产标准化标准、评定标准，以及对标准化工作的咨询、服务、评审、科研、管理和规划等。'
            },
            // {
            //   url:require('@/assets/home/yw.jpg'),
            //   title:'安全培训',
            //   content:'安全培训（Safety Training）是安全生产管理工作中一项十分重要的内容，它是提高全体劳动者安全生产素质的一项重要手段。'
            // },
      ],
      saveList:[
        {
          type:2,
          url:require('@/assets/type/2/1.png'),
          title:'场地调查',
          content:'提供从前期修复调查到后期修复评估一系列全过程的修复咨询服务，包括场地调查、风险评估、技术选择、方案制定、工程设计、工程实施、环境监理、效果评估、提出后期环境监管建议等。\n' +
            '1.提供前期调查和风险评估。结合场地的使用历史，调查可能存在的污染源，制定合理的调查及采样方案，确定特征污染物及污染区域。 \n' +
            '2.提供有效修复技术。针对不同的污染场地采取原位、异位相结合，轻度、重度分别处理，制定多种修复技术相结合的综合修复方案。 \n' +
            '3.提供工程咨询和监管。根据工程修复方案，对施工设计进行优化；对修复过程进行监督管理，控制施工风险，避免修复过程二次污染；对修复效果进行动态检测，提交验收依据，确保达到修复预期目标。 \n' +
            '4.提供具体工程修复实施。以实现项目目标和任务为中心，坚持安全第一、质量第一的方针，所有工程实践严格遵循国家现行法律、法规，设计规范、标准、施工图、公司ISO质量管理手册。 \n' +
            '5.提供在产企业及退役企业土壤和地下水污染防治咨询服务，包括企业拆除活动污染防治方案、企业拆除活动环境保护工作总结；重点企业新、改、扩建项目土壤和地下水现状调查、重点企业土壤和地下水自行监测等。'
        },
        {
          type:2,
          url:require('@/assets/type/2/2.png'),
          title:'环境影响评价',
          content:'对新建、改建、扩建项目对环境造成的影响的预见性评定。根据对项目所在地的各环境要素的影响以及法律法规的要求，来对项目所用原材料、可能产生的废弃物、项目的环保设施的设计的评价，从而评估项目建成对环自境的影响是否可接受。确保客户的运营符合国家相关环保的法律法规的要求'
        },
        {
          type:2,
          url:require('@/assets/type/2/3.png'),
          title:'环保管家',
          content:'以全面排查的方式，为政府、企业及园区提一站式综合环保服务，协助客户提升日常管理的水平，确保各项污染有效的治理。通过服务对企业环保问题全面分析和汇总，找准污染治理主要环节和风险，从而协助客户降低治污成本,提升环保管理水平。'
        },
      ],
      hygieneList:[
        {
          type:3,
          url:require('@/assets/type/3/1.png'),
          title:'职业卫生服务',
          content:'借助专业的EHS实务经验，为客户提供职业病危害申报及台账指导服务。协助客户识别工作场所职业病危害因素及其接触水平，同时提供职业病危害因素检测与评价服务，帮助客户掌握在正常生产过程职业病危害因素的浓度或强度、职业病危害管理现状以及满足新建、改建、扩建、技术改造等项目竣工验收的需要，从而不断提高客户的职业卫生绩效表现。'
        },
        // {
        //   url:require('@/assets/home/yw.jpg'),
        //   title:'场地调查与修复、应急处置',
        //   content:'建设项目职业病危害预评价是对可能产生职业病危害的建设项目，在可行性论证阶段，对建设项目可能产生的职业病危害因素、危害程度、对劳动者健康影响、防护措施等进行预测性卫生学分析与评价，确定建设项目在职业病防治方面的可行性，为职业病危害分类管理提供科学依据。'
        // },
        // {
        //   url:require('@/assets/home/yw.jpg'),
        //   title:'职业病危害效果评价',
        //   content:'建设项目职业病危害控制效果评价是建设项目在竣工验收前，对工作场所职业病危害因素、职业病危害程度、职业病防护措施及效果、健康影响等做出综合评价。'
        // },
      ],
      about: require('@/assets/home/about1.jpg')
    }
  },
  mounted() {
    // this.tabList=this.aqList
    let that = this
    axios.post('https://h5.mddslight.com/index.php/api/Suzhouhuanjing/fileList',{
    }).then(function (res) {
      that.docList = res.data.data
    })
    this.getOperation(this.mrIndex)

  },
  methods:{
    getOperation(index){
      let that = this
      axios.post('https://h5.mddslight.com/api/Suzhouhuanjing/getOperationNew?operation_status='+index+'',{
      }).then(function (res) {
        // console.log(res.data.data)
        that.tabList = res.data.data
      })
    },
    tzfile(){
      this.$router.push('./docList')
    },
    tabSelect(index){
      this.mrIndex=index
      if(index===0){
        this.getOperation(index)
      }else if(index===1){
        this.getOperation(index)
      }else if(index===2){
        this.getOperation(index)
      }
    },
    yewu(index){
      // if(type===1){
      //   this.$router.push({path:'./pubList?index='+1})
      // }else if(type===2){
      //   this.$router.push({path:'./pubList?index='+2})
      // }else if(type===3){
      //   this.$router.push({path:'./pubList?index='+3})
      // }
      //'./Vocational'+this.mrIndex,index
      this.$router.push(
        {
          path: './Vocational',
          query: {
            type: this.mrIndex,
            index: index
          }
        }
      )
    }

  }

}
</script>

<style scoped lang="scss">
.home {
  width: 100vw;
  overflow: auto;
  background: #F5F5F5;
  display: flex;
  flex-flow: column;
  .title-Box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.active{
      max-width: 1318px;
      min-width: 1180px;
      margin: 0 auto;
    }
  }
  .b-list{
    max-width: 1318px;
    min-width: 1180px;
    margin: 98px auto 0;
    display: flex;
    //justify-content: space-between;
    .item-box{
      width: 406px;
      //height: 340px;
      background-size: 100% 100%;
      margin-right: 50px;
      .item-con{
        width: 340px;
        padding: 33px;
        display: flex;
        flex-flow: column;
        align-items: center;
        .i-url{
          width: 340px;
          height: 218px;
         object-fit: fill;
        }
        .i-title{
          //width: 76.78px;
          height: 22px;
          font-weight: 700;
          font-size: 18px;
          line-height: 22px;
          color: #333333;
          margin-top: 20px;
        }
        .i-con{
          //width: 373.52px;
          width: inherit;
          height: 73px;
          font-weight: 400;
          //font-size: 14px;
          line-height: 1.5;
          color: #888888;
          overflow:hidden;
          text-overflow:ellipsis;
          display:-webkit-box;
          //-webkit-box-orient:vertical;
          //-webkit-line-clamp:2;
          //margin-top: 20px;
          text-align: justify;
        }
        .i-more{
          margin: 10px auto 0;
          background: #239584;
          border-radius: 2px;
          color: #FFFFFF;
          font-size: 18px;
          line-height: 25px;
          text-align: center;
          font-weight: 700;
          padding: 5px 27px;
        }
      }
    }
  }
  .title {
    width: 615px;
    height: auto;

    &.active {
      width: 241px;
      //margin: auto;
    }

    .chinese {
      width: 120px;
      height: 42px;
      font-weight: 700;
      font-size: 30px;
      line-height: 42px;
      color: #333333;
      margin-left: 7.5px;
    }

    .hx {
      width: 135px;
      height: 7px;
      margin-top: -11px;
      background: rgba(29, 181, 161, 0.14);
    }

    .eng {
      width: 300px;
      height: 28px;
      font-weight: 400;
      font-size: 16px;
      line-height: 177%;
      color: #CCCCCC;
      margin-left: 142px;
      margin-top: -24px;
    }

    .subtitle {
      width: 300px;
      height: 28px;
      font-weight: 700;
      font-size: 20px;
      line-height: 28px;
      color: #333333;
      margin-top: 23px;
    }

    .ab-con {
      width: inherit;
      height: auto;
      font-weight: 400;
      font-size: 16px;
      line-height: 1.5;
      color: #888888;
      margin-top: 18px;
    }
  }
  .more{
    width: 64px;
    height: 22px;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    color: #888888;
  }
  .about {
    max-width: 1318px;
    min-width: 1180px;
    height: 352px;
    margin: 98px auto;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;

    .a-cover {
      width: 635px;
      height: 352px;
      object-fit: cover;
      margin-right: 68px;
    }
  }

  .business {
    width: 100vw;
    height: 716px;
    background: #FFFFFF;
    //padding: 90px 295px 180px 295px;
    padding-top: 90px;
    &.active{
      height: auto;
    }
  }

  .tab {
    //width: 643px;
    height: 34px;
    //margin-left: 598px;
    //padding-right: 100px;
    display: flex;
    flex-flow: row nowrap;
    //justify-content: space-between;

    .t-text {
      height: 25px;
      font-weight: 700;
      font-size: 18px;
      line-height: 25px;
      color: #666666;
      text-align: center;
      padding: 5px 27px;
      margin: 0 20px;
      &.active {
        background: #239584;
        border-radius: 2px;
        color: #FFFFFF;
      }
    }
  }

  .file{
    height: auto;
    //margin: 90px auto;
    padding-top: 90px;
    .f-list{
      max-width: 1318px;
      min-width: 1180px;
      height: auto;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      //margin-top: 66px;
      margin: 66px auto;
      .f-cover{
        width: 418px;
        height: 291px;
        object-fit: cover;
      }
      .f-con{
        //display: flex;
        //flex-flow: column nowrap;
        //justify-content: space-between;
        .f-text{
          width: 844px;
          display: flex;
          flex-flow: row;
          height: 28px;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 20px;
          .f-dian{
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #1DB5A1;
          }
          .f-title{
            width: 641px;
            height: 28px;
            font-weight: 400;
            font-size: 20px;
            line-height: 28px;
            color: #333333;
            padding-right: 40px;
            //margin-left: -10px;
          }
          .f-time{
            width: 118px;
            height: 28px;
            font-weight: 400;
            font-size: 20px;
            line-height: 28px;
            color: #CCCCCC;
          }
        }
      }

    }

  }
  .comp{
    max-width: 1318px;
    min-width: 1180px;
    margin: 104px auto 0;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    .b-url{
      object-fit: cover;
    }
    .b-url:nth-child(1){
      width: 416px;
      height: 284px;
    }
    .b-url:nth-child(2){
      width: 329px;
      height: 442px;
    }
    .b-url:nth-child(3){
      width: 416px;
      height: 284px;
    }

  }
  .c-text{
    //width: 566px;
    height: 42px;
    font-weight: 700;
    font-size: 30px;
    line-height: 42px;
    margin-top: 56px;
    color: #333333;
    text-align: center;
  }
  .c-eng{
    //width: 566px;
    height: 42px;
    font-weight: 700;
    font-size: 30px;
    line-height: 42px;
    color: #CCCCCC;
    margin-top: 10px;
    text-align: center;
    margin-bottom: 150px;
  }
}
</style>
